import React from "react";
import Navbar from "../../components/Navbar/index.tsx";
import Footer from "../../components/Footer/index.tsx";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate, Link, useLocation } from "react-router-dom";
import api from "../../api/axios.tsx";

type VerifyResponse = {
  ok: boolean;
  paid?: boolean;
  subStatus?: string;
};

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [verifying, setVerifying] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  const [result, setResult] = React.useState<VerifyResponse | null>(null);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setVerifying(false);
      setError("Missing session id in URL");
      return;
    }

    const verify = async () => {
      setVerifying(true);
      setError(null);
      try {
        const serverUrl = process.env.REACT_APP_API_BASE_URL || "";
        const base = serverUrl.endsWith("/")
          ? serverUrl.slice(0, -1)
          : serverUrl;

        let res = await api.post(`${base}/payments/checkout_success`, {
          sessionId,
        });

        // TODO: handle response body if needed

        if (!res.data.ok) throw new Error("Verification failed");
        const data = res.data as VerifyResponse;
        setResult(data);
      } catch (e: any) {
        setError(e?.message || "Verification error");
      } finally {
        setVerifying(false);
      }
    };

    verify();
  }, [location.search]);

  return (
    <div className="page">
      <Navbar />
      <div className="pt-24 container-site max-w-3xl text-center">
        <div className="flex flex-col items-center gap-4">
          <div className="text-emerald-400">
            <FaCheckCircle size={64} />
          </div>
          <h1 className="heading-2">Payment Successful</h1>
          {verifying ? (
            <p className="subheading text-gray-300">
              Verifying your payment...
            </p>
          ) : error ? (
            <p className="subheading text-rose-300">{error}</p>
          ) : (
            <p className="subheading text-gray-300">
              Thank you!{" "}
              {result?.paid
                ? "Your payment is confirmed."
                : "Payment status received."}
              {result?.subStatus ? ` Subscription: ${result.subStatus}.` : ""}
            </p>
          )}
          <div className="mt-6 flex gap-3 justify-center">
            <button
              className="btn-primary"
              onClick={() => navigate("/dashboard")}
            >
              Go to Dashboard
            </button>
            <Link to="/subscriptions" className="btn-secondary">
              Manage Subscriptions
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentSuccess;
